import { FullPageLoader } from '@color/continuum';
import { loggerUtils } from '@color/lib';
import { useEffect } from 'react';

export const AngularReloader = () => {
  /**
   * `useEffect` is often dangerous and unnecessary. This usage needs review by #ux-programs team.
   * See https://getcolor.atlassian.net/browse/UXTASK-1406
   */
  // nosemgrep:semgrep-rules.ui-useEffect
  useEffect(() => {
    loggerUtils.logMessage(
      new Error(`Force the UI to reload on ${window.location.pathname} for Angular.`)
    );
    window.location.reload();
  }, []);

  return <FullPageLoader />;
};
